module.exports = __webpack_public_path__ + "static/media/Piercing-tongue-verticalsymmetry.09675965.png";